/**
*
*   Login
*       - The Login Button
*
**/
'use client';

//
import PageLoader from '@/libraries/pageloader';
import { Link } from '@/libraries/navigation';
import { signIn } from 'next-auth/react';
import { useLocale } from 'next-intl';


//Build the Element
export default function Login({ children , ...rest }){

	//Get the Locale
	const locale = useLocale();

	//Prepare the Class
	const Login = {

		//Generate the Login
		generate: async () => {

			//Start the Page Transition
			PageLoader.start();

			//Login
			return signIn('shopify');

		}

	};

	return (
		<Link href="/account/login" className="login" {...rest}>
			{ children }
		</Link>
	);


/*
	//Return
	return (
		<a onClick={Login.generate} className="login" {...rest}>
			{ children }
		</a>
	);
*/
}